var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item pb-3 mb-5 border-bottom",
      attrs: { id: "leaflet--" + _vm.element.id }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm.element.name
            ? _c("h2", { staticClass: "col-12" }, [
                _vm._v(_vm._s(_vm.element.name))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "col-12" }, [
            _c("i", { staticClass: "fad fa-calendar-week" }),
            _vm._v(
              " Gültig: " +
                _vm._s(_vm.startDate) +
                "\n                " +
                _vm._s(_vm.endDate) +
                " "
            )
          ]),
          _vm._v(" "),
          _vm.element.description
            ? _c("div", {
                staticClass: "col-12",
                domProps: { innerHTML: _vm._s(_vm.element.description) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.filePath
            ? _c("div", { staticClass: "col-12 text-right align-self-end" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-outline-secondary btn-sm",
                    attrs: { href: _vm.filePath, target: "_blank" }
                  },
                  [
                    _vm._v("\n                    Flugblatt herunterladen "),
                    _c("i", { staticClass: "fad fa-download" })
                  ]
                )
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }